import React, {createRef, useContext, useLayoutEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import FormHelperText from "@material-ui/core/FormHelperText";
import LoadingOverlay from "react-loading-overlay";
import '../../resources/css/application.css';
import "../../resources/css/custom-react-gallery-carousel.css";
import styled, {css} from "styled-components";
import {imagesValidation, mailMask, mailValidation, validateOib} from "../../util/ValidationUtil";
import {AXIOS_UPLOAD_SERVER, ENV} from "../../util/Util";
import ImagesPreview from "./ImagesPreview";
import ImageUpload from "./ImageUpload";
import EditDialog from "../popup/EditDialog";
import InfoAlert from "../alert/InfoAlert";
import {Context} from "../../App";
import WarningAlert from "../alert/WarningAlert";
import Header from "../common/Header";
import Footer from "../common/Footer";
import ErrorAlert from "../alert/ErrorAlert";

const TOTAL_FIELDS_NUMBER = 2;
const IMAGE_1 = [0, "Potvrda-o-upisu-akademske-godine-1"];
const IMAGE_2 = [1, "Potvrda-o-upisu-akademske-godine-2"];

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${props => props.disappear && css`
      display: block; /* show */
    `}`;

const UploadDocumentsPage = () => {

  const history = useHistory();
  const fieldRefs = useRef(Array.from({length: TOTAL_FIELDS_NUMBER}, () => createRef()));
  const mailRef = useRef();
  const {uploadData} = useContext(Context);
  const [uploadDataState, setUploadDataState] = uploadData;
  const [message, setMessage] = useState(null);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [warningFlag, setWarningFlag] = useState(false);
  const [errorAlertFlag, setErrorAlertFlag] = useState(false);
  const [errorPageFlag, setErrorPageFlag] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  useLayoutEffect(() => {
    history.go(1);
  }, [history]);

  const changeUploadState = (name, value) => {
    setUploadDataState({...uploadDataState, [name]: value});
  };

  const onOpenEditDialog = () => {
    setDialogOpen(true);
  };

  const onCloseEditDialog = () => {
    setDialogOpen(false);
  };

  const openImagesPreview = () => {
    uploadDataState.images.forEach(value => {
      if (value !== null) {
        setShowPreview(true);
      }
    });
  };

  const getImagesData = () => {
    let imageFiles = [];
    uploadDataState.images.forEach((value, index) => {
      if (value != null) imageFiles[index] = value.file;
    });
    return imageFiles;
  };

  const setFormData = (uploadId, token, mail, uploadHash, images) => {
    const formData = new FormData();
    formData.append("uploadId", uploadId);
    formData.append("token", token);
    formData.append("mail", mail);
    formData.append("uploadHash", uploadHash);
    images.forEach((file) => formData.append("image[]", file));
    return formData;
  };

  const submitForm = async () => {
    setErrorAlertFlag(false);
    setSubmitFlag(true);
    if (getImagesData().length==0) {
      setMessage("Potrebno je priložiti barem jedan dokument.");
      setWarningFlag(true);
      console.log("Broj dokumenata: " + getImagesData().length);
      return false;
    }
    /*if (!imagesValidation(uploadDataState, fieldRefs)) {
      return false;
    }*/
    if (mailValidation(uploadDataState.mail)) {
      mailRef.current.focus();
      return false;
    }
    if (!uploadDataState.uploadId || !uploadDataState.token || !validateOib(uploadDataState.oib)) {
      setMessage("Potrebno je napraviti provjeru OIB-a na početnoj stranici");
      setWarningFlag(true);
      return false;
    }
    setShowSpinner(true);
    await AXIOS_UPLOAD_SERVER.post("upload/studenti/", setFormData(uploadDataState.uploadId, uploadDataState.token, uploadDataState.mail, uploadDataState.uploadHash, getImagesData()),
      {headers: {'Content-Type': 'multipart/form-data'}})
      .then(() => {
        history.push(ENV.REACT_APP_SUCCESS_PAGE);
      }).catch((error) => {
        setErrorAlertFlag(true);
        if (error.response && error.response.status === 400) {
          setMessage(error.response.data);
          return;
        }
        setMessage("Došlo je do pogreške prilikom spremanja podataka, molimo, pokušajte ponovo");
        errorPageFlag ? history.push(ENV.REACT_APP_ERROR_PAGE) : setErrorPageFlag(true);
      }).finally(() => {
        setShowSpinner(false);
      });
  };

  return (
    <div className="site">

      <Header/>

      <main className="site-content">

        <div className="container">

          <div className="card card--pullup card--content-center">
            <div className="w-md-75">


              <form onSubmit={event => event.preventDefault()}>

                <div className="mb-9">
                  <h2 className="headline-2 mb-5">Potvrda o upisu akademske godine</h2>

                  <InfoAlert
                    message={"Potvrda o upisu akademske godine može sadržavati jednu do dvije stranice te sukladno tome učitajte jednu ili dvije datoteke"}/>

                  <div className="row mb-5">
                    <label className="col-sm-3 col-md-2 col-form-label-upload">Stranica 1</label>
                    <div className="col-sm-8">
                      <ImageUpload images={uploadDataState.images} propertyNameInState="images"
                                   setImages={changeUploadState} index={IMAGE_1[0]} fieldRefs={fieldRefs}
                                   newImageName={IMAGE_1[1]} submitFlag={submitFlag}/>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <label className="col-sm-3 col-md-2 col-form-label-upload">Stranica 2</label>
                    <div className="col-sm-8">
                      <ImageUpload images={uploadDataState.images} propertyNameInState="images"
                                   setImages={changeUploadState} index={IMAGE_2[0]} fieldRefs={fieldRefs}
                                   newImageName={IMAGE_2[1]} submitFlag={submitFlag}/>
                    </div>
                  </div>
                </div>

                {/*<!-- -->*/}

                <div className="mb-9">
                  <h2 className="headline-2 mb-5">E-mail</h2>

                  <InfoAlert
                    message={"E-mail je potrebno unijeti kako bismo ti mogli poslati obavijest o zaprimanju dokumentacije"}/>

                  <div className="row mb-5">
                    <label className="col-sm-3 col-md-2 col-form-label-mail">Vaš e-mail</label>
                    <div className="col-sm-8">
                      <div
                        className={submitFlag && mailValidation(uploadDataState.mail) ? "mail-container mail-container-error" : "mail-container"}
                        tabIndex={1} ref={mailRef}>
                        {!mailValidation(uploadDataState.mail) ?
                          <p className={"mail-text"}>{mailMask(uploadDataState.mail)}</p> :
                          <p className={"placeholder-text"}>Unesite e-mail</p>}
                        <p onClick={onOpenEditDialog} className="edit-icon"/>
                      </div>
                      {<div className="error-text">
                        <FormHelperText error={submitFlag && mailValidation(uploadDataState.mail)}>
                          {submitFlag && mailValidation(uploadDataState.mail) ? "Unos ovog polja je obavezan" : null}
                        </FormHelperText>
                      </div>}
                    </div>
                  </div>

                  {warningFlag && <WarningAlert message={message}/>}
                  {errorAlertFlag && <ErrorAlert message={message}/>}

                </div>
              </form>

              <div className="submit-buttons-container">
                <button type="submit" className="btn btn--secondary btn--xs-full-width mr-md-2 mb-3"
                        onClick={openImagesPreview}>Pregledaj dokumente
                </button>
                <button type="submit" className="btn btn--primary btn--xs-full-width mr-md-2 mb-3"
                        onClick={submitForm}>Pošalji dokumente
                </button>
              </div>

              <DarkBackground disappear={showSpinner}>
                <LoadingOverlay active={true} spinner={true} text="Obrada podataka u tijeku...">
                </LoadingOverlay>
              </DarkBackground>

              {showPreview && <ImagesPreview images={uploadDataState.images} showPreview={showPreview}
                                             setShowPreview={setShowPreview}/>}

              <EditDialog open={dialogOpen}
                          onChangeFieldValue={changeUploadState}
                          onClose={onCloseEditDialog}
                          message={uploadDataState.mail ? "Molimo potvrdi izmjenu svoje e-mail adrese" : "Upišite novu e-mail adresu"}
                          fieldPlaceholder={"primjer@email.com"}
                          propertyName="mail"
                          fieldValidationMsg={"Upisana e-mail adresa nije ispravna"}
                          fieldValidation={mailValidation}/>
            </div>
          </div>
        </div>
      </main>

      <Footer/>

    </div>
  );
};

export default UploadDocumentsPage;